'use client';
import { arrayOf, omitUndefined } from '@s7/utils';
import { serializeHeaders } from './serializeHeaders.js';

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/**
 * Учитывает следующие параметры опций клиента:
 * - `prefixUrl`
 * - `json`
 * - `searchParams`
 * - `method`
 * - `headers`
 * */ var serializeQuery = function(query) {
    var _arrayOf = arrayOf(query), input = _arrayOf[0], options = _arrayOf[1];
    if (!options) {
        return String(input);
    }
    return JSON.stringify(omitUndefined({
        i: input,
        p: options.prefixUrl,
        j: options.json,
        s: options.searchParams,
        m: options.method,
        h: options.headers
    }), function(_, value) {
        return _instanceof(value, Headers) ? serializeHeaders(value) : value;
    });
};

export { serializeQuery };
